import Portfolio from "../../../commonComponents/portfolio";

const Portfolio2GridContainer = () => {
  return <Portfolio />;
};

export default Portfolio2GridContainer;
